import { AppsFlyer } from '../utils';

/**
 * AppsFlyer integration.
 * Disabled on web.
 */
export const useAppsFlyer = (): AppsFlyer => {
  return mockAppsFlyer;
};

const mockAppsFlyer: AppsFlyer = {
  async initialize() {},
  setCustomerUserId(_customerId) {},
  logEvent(_name) {},
  logPurchaseEvent(_payload) {},
};
